import React  from 'react';
import OnespBasicInfoComponent from './one-user-provider-login-info.component';
import OnespAccountInfoComponent from './onesp-account-info.component';
import OnespUserProfileInfoComponent from './onesp-user-profile-info.component';
import OnespAddressComponent from './onesp-primary-adress-info.component';
import OnespInfoComponent from './one-service-provider-info.component';
import TabContainer from '../../../../../common/components/tab/containers/tab.containers';



export const OnespComponent = ({handleBasicFormChange, selectedAddress,handleInnerFormChange,id,tagNames,selectedOnesp,back,accounts,handleFormSubmit,gstType,gstRegistrationType}: any) => {
  const tabItems=[
    {
        id:1,
        title:'Onsp Details',
        component:<OnespBasicInfoComponent 
        handleInnerFormChange={handleInnerFormChange}
        selectedOnesp={selectedOnesp}
        id={id}
        tagNames={tagNames}
       />,
    isVisible:true,
    },
    {
      id:2,
      title:'Account Info',
      component:<OnespAccountInfoComponent 
      handleInnerFormChange={handleInnerFormChange}
      selectedOnesp={selectedOnesp}
      accounts={accounts}
      handleBasicFormChange={handleBasicFormChange}
     />,
  isVisible:true,
  },
    {
        id:3,
        title:'User Profile',
        component:<OnespUserProfileInfoComponent 
        handleInnerFormChange={handleInnerFormChange}
        selectedOnesp={selectedOnesp}
       />,
    isVisible:true,
    },
    {
      id: 4,
      title: 'Address',
      component: <OnespAddressComponent
        onInnerFormChange={handleInnerFormChange}
        selectedAddress={selectedOnesp}
      />,
      isVisible: true,
    },

    //  {
    //     id:5,
    //     title:'Tax Info',
    //     component:<OnespTaxDetailsComponent 
    //     handleInnerFormChange={handleInnerFormChange}
    //     selectedOnesp={selectedOnesp}
    //     gstType={gstType}
    //     gstRegistrationType={gstRegistrationType}
    //    />,
    // isVisible:true,
    // },

     {
        id:6,
        title:'Onesp Info',
        component:<OnespInfoComponent 
        handleInnerFormChange={handleInnerFormChange}
        selectedOnesp={selectedOnesp}
        tagNames={tagNames}
       />,
    isVisible:true,
    },
   

  ]
    
  return (
    <div className="flex flex-col items-center w-full px-5 h-[620px] overflow-auto">
       
     
      <TabContainer tabItems={tabItems} />
   
      <div className='flex w-full justify-end items-end'>
        <button
              onClick={back}
              type='button'
              className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
             >
              Back
             </button>
             <button
            className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
              onClick={handleFormSubmit}
            
              type="submit"
          >
            Save
          </button>
        </div>
       </div>
  )
}
export default OnespComponent;
